import React from 'react';
import { Box, Skeleton } from '@mui/material';
import {
  Assessment,
  CheckCircle,
  TrendingUp,
  Visibility,
  Warning as WarningIcon,
  Speed,
} from '@mui/icons-material';
import { Tile, fmt, fmtScore } from './shared';
import { colors, status } from '../../theme';

export default function SummaryTilesSection({ t, loading, hasScanResult, totalScanned, filteredCount, readyCount, watchCount, radarCount, avoidCount, avgScore, maxScore }) {
  if (loading && !hasScanResult) {
    return (
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(6, 1fr)' }, gap: 1.5, mb: 2.5 }}>
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <Box key={i} sx={{ borderRadius: 1.5, border: `1px solid ${colors.gray[100]}`, bgcolor: colors.background.paper, p: '14px 16px', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Skeleton variant="rounded" width={38} height={38} sx={{ borderRadius: 2, flexShrink: 0 }} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="50%" height={14} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="40%" height={24} sx={{ mb: 0.3 }} />
              <Skeleton variant="text" width="65%" height={12} />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(6, 1fr)' }, gap: 1.5, mb: 2.5 }}>
      <Tile Icon={Assessment} label={t('vpa.tiles.scanned')} value={fmt(totalScanned)} sub={`${t('vpa.tiles.shown')}: ${filteredCount}`} color={colors.gray[500]} />
      <Tile Icon={CheckCircle} label={t('vpa.tiles.ready')} value={fmt(readyCount)} sub={t('vpa.tiles.readySub')} color={colors.success.dark} />
      <Tile Icon={Visibility} label={t('vpa.tiles.watch')} value={fmt(watchCount)} sub={t('vpa.tiles.watchSub')} color={colors.info.main} />
      <Tile Icon={Speed} label={t('vpa.tiles.radar')} value={fmt(radarCount)} sub={t('vpa.tiles.radarSub')} color={colors.warning.main} />
      <Tile Icon={WarningIcon} label={t('vpa.tiles.avoid')} value={fmt(avoidCount)} sub={t('vpa.tiles.avoidSub')} color={colors.error.main} />
      <Tile Icon={TrendingUp} label={t('vpa.tiles.avgScore')} value={fmtScore(avgScore)} sub={`${t('vpa.tiles.max')} ${fmtScore(maxScore)}`} color={status.purple.main} />
    </Box>
  );
}
